export default "__VITE_ASSET__BcoQyZke__"